import React, { ReactElement, FCC } from 'react';
import { IWizardStepProps } from './types';
import { WizardStep } from './WizardStep';

export interface IWizardCustomStepProps extends IWizardStepProps {
  children: ReactElement<{}>;
}

export const WizardCustomStep: FCC<IWizardCustomStepProps> = (props) => {
  return (
    <WizardStep {...props} type={'custom'}>
      {props.children}
    </WizardStep>
  );
};

export default WizardCustomStep;
